import { post } from '../utils/http';

export function userForgetPassword(param) {
    return post('v1/admin/email/verify/send', param);
}